// extracted by mini-css-extract-plugin
module.exports = {"drawingTool":"drawingTool__drawingTool___BuqWI","canvasWrapper":"drawingTool__canvasWrapper___04K-I","modalButtonMinimize":"drawingTool__modalButtonMinimize___9yjqD"};